import { useAccountCompanyId } from 'application/hooks';
import { usePaymentMethodRepositoryInjector } from 'application/providers/DIContainerProvider';

const useCardBindModalPresenter = () => {
  const companyId = useAccountCompanyId();

  const { getLinkForBindingCard: getLinkForBindingCardRepository, bindCardLoading } =
    usePaymentMethodRepositoryInjector();

  const getLinkForBindingCard = async (pathname: string) => {
    const link = await getLinkForBindingCardRepository(pathname, companyId);

    return link;
  };

  return {
    getLinkForBindingCard,
    bindCardLoading,
  };
};

export default useCardBindModalPresenter;
